import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Prints.css';

const Prints = () => {
  const printCollections = [
    {
      id: 'black-white',
      title: 'Black & White Collection',
      image: '/bw1.jpg',
      link: '/collection/black-white'
    },
    {
      id: 'pink',
      title: 'Pink Collection',
      image: '/pink1.jpg',
      link: '/collection/pink'
    }
  ];

  return (
    <div className="prints">
      <motion.section
        className="prints-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="prints-hero-content">
          <motion.h1
            className="prints-hero-title"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Fine Art Prints
          </motion.h1>
          <motion.div
            className="prints-hero-message"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <p className="prints-disclaimer">ORIGINALS NOT FOR SALE</p>
            <p className="prints-availability">PRINTS AVAILABLE SOON</p>
          </motion.div>
        </div>
      </motion.section>

      <section className="prints-collection-section">
        <div className="prints-container">
          <motion.div
            className="prints-grid"
            initial="hidden"
            animate="visible"
            variants={{
              visible: {
                transition: {
                  staggerChildren: 0.2
                }
              }
            }}
          >
            {printCollections.map((collection) => (
              <motion.div
                key={collection.id}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0 }
                }}
                transition={{ duration: 0.6 }}
              >
                <Link to={collection.link} className="print-collection-card">
                  <div className="print-collection-image">
                    <img src={collection.image} alt={collection.title} />
                    <div className="print-collection-overlay">
                      <div className="print-overlay-content">
                        <h2>{collection.title}</h2>
                        <span className="view-collection-text">
                          View Collection
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <motion.section
        className="prints-cta-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="prints-cta-content">
          <h2>Interested in Prints?</h2>
          <p>
            Contact us to be notified when prints become available.
          </p>
          <Link to="/contact" className="prints-cta-button">
            Contact Us
          </Link>
        </div>
      </motion.section>
    </div>
  );
};

export default Prints;
